import { Box, SxProps, useTheme } from '@mui/material';
import { UiContext } from 'shared/lib/contexts/uiContext';
import React, { useContext } from 'react';

export default function ButtonsContainer({
  children,
  variant = 'full',
  sx,
}: {
  children: React.ReactNode;
  variant?: 'near' | 'full' | 'vertical';
  sx?: SxProps;
}) {
  const { spacings } = useContext(UiContext);
  const theme = useTheme();

  return variant === 'full' ? (
    <Box
      sx={{
        'display': 'flex',
        'flexWrap': 'wrap',
        'width': '100%',
        'gap': spacings.sp.s40,
        '& > *': {
          flexBasis: `calc(50% - ${theme.spacing(spacings.sp.s40 / 2)})`,
          minWidth: `max-content`,
          flexGrow: 1,
          // @ts-ignore
          ...(sx?.['& > *'] || {}),
        },
        ...sx,
      }}
    >
      {children}
    </Box>
  ) : variant === 'near' ? (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        width: 'fit-content',
        gap: spacings.sp.s40,
        ...sx,
      }}
    >
      {children}
    </Box>
  ) : (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: spacings.sp.s20,
        ...sx,
      }}
    >
      {children}
    </Box>
  );
}
